<div class="invoice-body">
  <div class="row" *ngIf="invoiceTemplateModel.logoAlignment=='Left'">
    <div class="col-md-6">
      <input
        type="file"
        name="myImage"
        accept="image/x-png,image/gif,image/jpeg"
        style="display: none"
      />
      <div
        class="logo logo-left logo-add"
        [style.background-image]="backgroundImg"
        style="
          background-repeat: no-repeat;
          background-position: center left;
          background-size: contain;
        "
      ></div>
    </div>
    <div class="col-md-6">
      <div class="account-details right">
        <h2 [style.color]="invoiceTemplateModel.fontColor">
          {{ businessInfo.BusinessName}}
        </h2>
        <p [style.color]="invoiceTemplateModel.fontColor">
          {{ businessInfo.Address1 }}, {{ businessInfo.City }},
          {{businessInfo.StateId}} {{ businessInfo.PostalCode
          }}{{businessInfo.CountryCode ? ' ' + businessInfo.CountryCode : ''}}
        </p>
        <p
          *ngIf="locationData && locationData.BranchName && !locationData.IsLocationNameDisplayed"
          [style.color]="invoiceTemplateModel.fontColor"
        >
          Location : {{locationData ? locationData.BranchName : ''}}
        </p>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="invoiceTemplateModel.logoAlignment=='Right'">
    <div class="col-md-6">
      <div class="account-details left">
        <h2 [style.color]="invoiceTemplateModel.fontColor">
          {{ businessInfo.BusinessName}}
        </h2>
        <p [style.color]="invoiceTemplateModel.fontColor">
          {{ businessInfo.Address1 }}, {{ businessInfo.City }},
          {{businessInfo.StateId}} {{ businessInfo.PostalCode
          }}{{businessInfo.CountryCode ? ' ' + businessInfo.CountryCode : ''}}
        </p>
        <p [style.color]="invoiceTemplateModel.fontColor">
          {{ businessInfo.ContactNumber }}
        </p>
        <p [style.color]="invoiceTemplateModel.fontColor">
          Location : {{locationData ? locationData.BranchName : ''}}
        </p>
      </div>
    </div>
    <div
      class="logo logo-left col-md-6"
      [style.background-image]="backgroundImg"
      style="
        background-repeat: no-repeat;
        background-position: center right;
        background-size: contain;
      "
    ></div>
  </div>
  <div class="row" *ngIf="invoiceTemplateModel.logoAlignment=='Center'">
    <div
      class="logo logo-left col-md-12"
      [style.background-image]="backgroundImg"
      style="
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      "
    ></div>
    <div class="col-md-12">
      <div class="account-details center">
        <h2 [style.color]="invoiceTemplateModel.fontColor">
          {{ businessInfo.BusinessName}}
        </h2>
        <p [style.color]="invoiceTemplateModel.fontColor">
          {{ businessInfo.Address1 }}, {{ businessInfo.City }},
          {{businessInfo.StateId}} {{ businessInfo.PostalCode
          }}{{businessInfo.CountryCode ? ' ' + businessInfo.CountryCode : ''}}
        </p>
        <p [style.color]="invoiceTemplateModel.fontColor">
          Location : {{locationData ? locationData.BranchName : ''}}
        </p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h1 [style.background]="invoiceTemplateModel.accentColor">
        Sales Invoice
      </h1>
    </div>
    <div class="col-md-3">
      <div class="account-details border-none no-padding">
        <h3>Bill to:</h3>
        <p>
          <span
            [style.color]="invoiceTemplateModel.fontColor"
            *ngIf="customerInfo.CustomerTypeId == 1"
            >{{ customerInfo.FirstName }} {{ customerInfo.LastName }}</span
          >
          <span
            [style.color]="invoiceTemplateModel.fontColor"
            *ngIf="customerInfo.CustomerTypeId == 2"
            >{{ customerInfo.BusinessName }}</span
          >
        </p>
      </div>
      <div class="account-details border-none no-padding">
        <h3>Customer Address:</h3>
        <p>
          <span [style.color]="invoiceTemplateModel.fontColor">
            {{ customerAddress }}</span
          >
        </p>
      </div>
      <div class="account-details border-none no-padding">
        <h3>Additional Details:</h3>
        <p *ngFor="let field of customFieldValues;let i = index;">
          <label
            [style.color]="invoiceTemplateModel.fontColor"
            style="width: 100px"
            *ngIf="field.fieldDataType === 104"
            >{{field.fieldName}}</label
          ><strong
            [style.color]="invoiceTemplateModel.fontColor"
            style="margin-left: 25px"
            *ngIf="field.fieldDataType === 104"
          >
            <!-- <cj-checkbox
              id="customFieldId{{i}}"
              name="customfield[{{ i }}]"
              style="pointer-events: none;"
              size="small"
              disabled="true"
              [ngModel]="field.fieldValue"
            ></cj-checkbox> -->
            {{ field.fieldValue && field.fieldValue === 'true' ? 'Yes' : 'No' }}
          </strong>
          <label
            [style.color]="invoiceTemplateModel.fontColor"
            style="width: 100px"
            *ngIf="field.fieldDataType !== 104"
            >{{field.fieldName}}</label
          ><strong
            [style.color]="invoiceTemplateModel.fontColor"
            style="margin-left: 25px"
            *ngIf="field.fieldDataType !== 104"
            >{{ field.fieldValue }}</strong
          >
        </p>
      </div>
      <div class="account-details border-none no-padding">
        <h3>Notes:</h3>
        <p>
          <span [style.color]="invoiceTemplateModel.fontColor">
            {{ manualInvoice.Notes }}</span
          >
        </p>
      </div>
    </div>
    <div class="col-md-9">
      <div class="invoice-details nomargin">
        <p>
          Invoice #<span [style.color]="invoiceTemplateModel.fontColor"
            >{{ manualInvoice.InvoiceNumber ? manualInvoice.InvoiceNumber :
            '000-000-0000' }}</span
          >
        </p>
        <p>
          Invoice Date
          <span [style.color]="invoiceTemplateModel.fontColor"
            >{{ manualInvoice.InvoiceDate | date:'MM/dd/yyyy'}}</span
          >
        </p>
        <p>
          Due date
          <span [style.color]="invoiceTemplateModel.fontColor"
            >{{ manualInvoice.DueDate | date:'MM/dd/yyyy'}}</span
          >
        </p>
      </div>
      <!-- <div class="invoice-details nomargin">
        <p>
          Voucher Code
          <span [style.color]="invoiceTemplateModel.fontColor"></span>
        </p>
        <p>
          Regular Customer
          <span [style.color]="invoiceTemplateModel.fontColor"></span>
        </p>
        <p>
          Assigned Employees / Staffs
          <span *ngFor="let item of assigndEmployees">
            <small [style.color]="invoiceTemplateModel.fontColor"
              >{{item.employeeName}} {{ item.emailAddress }} / {{
              item.phoneNumber ? item.phoneNumber : 'N / A' }}</small
            >
          </span>
          <br />
        </p>
      </div> -->
    </div>
  </div>

  <table class="invoice-table">
    <thead>
      <tr>
        <th>Item/Service</th>
        <th>Unit Cost</th>
        <th>Quantity</th>
        <th>Is Tax Exempt</th>
        <!-- <th>Tax Exempt</th> -->
        <th>Line Total</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of invoiceItems">
        <td
          [style.color]="invoiceTemplateModel.fontColor"
          [class.with-description]="item.ServiceDescription || getL2L3Description(item)"
        >
          {{ item.ItemName }}
          <div class="item-description">
            <div *ngIf="item.ServiceDescription">
              {{ item.ServiceDescription }}
            </div>

            <ng-container *ngIf="getL2L3Description(item)">
              <br />
              <div class="l2l3-description">
                <span *ngIf="item.TaxAmount"
                  >Tax Amount: {{ item.TaxAmount }}</span
                >
                <span *ngIf="item.TaxType"
                  >Tax Indicator: {{ item.TaxType }}</span
                >
                <span *ngIf="item.ProductCode"
                  >Purchase ID: {{ item.ProductCode }}</span
                >
                <span *ngIf="item.ItemCommodityCode"
                  >Commodity Code: {{ item.ItemCommodityCode }}</span
                >
                <span *ngIf="item.UnitOfMeasure"
                  >Unit of Measure: {{ item.UnitOfMeasure }}</span
                >
                <span *ngIf="item.DiscountAmount"
                  >Discount: {{ item.DiscountAmount }}</span
                >
                <span *ngIf="item.TaxTreatment"
                  >Tax Treatment: {{ item.TaxTreatment }}</span
                >
              </div>
            </ng-container>
          </div>
        </td>
        <td [style.color]="invoiceTemplateModel.fontColor">
          $ {{ item.Rate ? item.Rate.toFixed(2) : '0.00' }}
        </td>
        <td [style.color]="invoiceTemplateModel.fontColor">
          {{ item.Quantity }}
        </td>
        <td [style.color]="invoiceTemplateModel.fontColor">
          {{ item.IsTaxExempt ? 'Yes' : 'No' }}
        </td>
        <!-- <td [style.color]="invoiceTemplateModel.fontColor">{{ item.IsTaxExempt ? item.Amount.toFixed(2) : '' }}</td> -->
        <td [style.color]="invoiceTemplateModel.fontColor">
          $ {{ item.Amount ? item.Amount.toFixed(2) : '0.00' }}
        </td>
      </tr>
    </tbody>
  </table>
  <div class="adjustments">
    <div class="form-group">
      <label>Line total</label>
      <p [style.color]="invoiceTemplateModel.fontColor">
        $ {{ manualInvoice.TotalAmount ? manualInvoice.TotalAmount.toFixed(2) :
        '0.00' }}
      </p>
    </div>
    <div class="form-group">
      <label>Gross Total</label>
      <p [style.color]="invoiceTemplateModel.fontColor">
        $ {{ grossTotal ? grossTotal.toFixed(2) : '0.00' }}
      </p>
    </div>
    <div class="form-group">
      <label>Partial Amount</label>
      <p [style.color]="invoiceTemplateModel.fontColor" *ngIf="partialPayment">
        {{ partialPayment.partialDueType === 'USD' ? '$' : '%' }} {{
        partialPayment.partialDue ? partialPayment.partialDue.toFixed(2) :
        '0.00' }}
      </p>
      <p *ngIf="!partialPayment">-</p>
    </div>
    <div
      class="form-group"
      *ngIf="manualInvoice.Tax && manualInvoice.TaxableTotal"
    >
      <label>Taxable Total</label>
      <p [style.color]="invoiceTemplateModel.fontColor">
        $ {{ manualInvoice.TaxableTotal ? manualInvoice.TaxableTotal.toFixed(2)
        : '0.00' }}
      </p>
    </div>
    <div
      class="form-group"
      *ngIf="manualInvoice.Tax && manualInvoice.NonTaxableTotal"
    >
      <label>Non-taxable Total</label>
      <p [style.color]="invoiceTemplateModel.fontColor">
        $ {{ manualInvoice.NonTaxableTotal ?
        manualInvoice.NonTaxableTotal.toFixed(2) : '0.00' }}
      </p>
    </div>
  </div>
  <div class="adjustments adjustments-lg">
    <h3>Adjustments</h3>
    <div class="invoice-details">
      <p *ngIf="totalDeposits > 0">
        Deposits<span [style.color]="invoiceTemplateModel.fontColor"
          >$ {{ totalDeposits.toFixed(2) }}</span
        >
      </p>
      <p>
        Discount<span [style.color]="invoiceTemplateModel.fontColor"
          >{{ manualInvoice.DiscountType }} {{ manualInvoice.Discount ?
          manualInvoice.Discount.toFixed(2) : '0.00' }}</span
        >
      </p>
      <p *ngIf="displayTipAmt">
        Tip<span [style.color]="invoiceTemplateModel.fontColor"
          >$ {{ tipAmt.toFixed(2) }}</span
        >
      </p>
      <p>
        {{ manualInvoice.UpchargeName === 'Custom upcharge' ? 'Upcharge' :
        manualInvoice.UpchargeName }}
        <span [style.color]="invoiceTemplateModel.fontColor"
          >{{ manualInvoice.UpchargeType }} {{ manualInvoice.Upcharge ?
          manualInvoice.Upcharge.toFixed(2) : '0.00' }}</span
        >
      </p>
      <p class="nohover">
        Tax<span
          >{{ manualInvoice.TaxType }} {{ manualInvoice.Tax ?
          manualInvoice.Tax.toFixed(2) : '0.00' }}</span
        >
      </p>
    </div>
  </div>
  <div class="total" [style.background]="invoiceTemplateModel.accentColor">
    <div class="form-group grand">
      <label style="color: white">Invoice Amount</label>
      <p style="color: white">
        $ {{ totalInvoiceAmount ? totalInvoiceAmount.toFixed(2) : '0.00' }}
      </p>
      <div>
        <span
          class="tag-pill uppercase"
          [class]="'tag-'+ manualInvoice?.Status.toLocaleLowerCase() || 'paid' "
          >{{ manualInvoice.Status || 'Paid' }}</span
        >
      </div>
    </div>
    <div class="form-group" *ngIf="!partialPayment; else amountPartial">
      <label style="color: white">Amount Due</label>
      <p style="color: white">
        $ {{ manualInvoice.Balance && manualInvoice.Status !== 'Paid' ?
        manualInvoice.Balance.toFixed(2) : '0.00' }}
      </p>
    </div>
    <ng-template #amountPartial>
      <div class="form-group">
        <label style="color: white">Partial Amount Due</label>
        <p style="color: white" class="currency-item">
          {{ this.manualInvoice.Status !== "Partial" ? (getPartialAmountDue() |
          currency) : (0 | currency) }}
        </p>
      </div>
      <div class="form-group">
        <label style="color: white">Total Amount Due</label>
        <p style="color: white" class="currency-item">
          {{ this.manualInvoice.Status !== "Partial" ? (totalInvoiceAmount |
          currency) : (this.manualInvoice.AmountDue | currency) }}
        </p>
      </div>
    </ng-template>
  </div>
</div>
<div class="transaction-details" *ngFor="let item of manualInvoicePayments">
  <div class="form-group flex flex-col gap-1">
    <label>Transaction ID</label>
    <span>{{item.transactionId}}</span>
  </div>
  <div class="form-group flex flex-col gap-1">
    <label>Payment Date</label>
    <span>{{item.date | date:'MM/dd/yyyy'}}</span>
  </div>
  <div class="form-group flex flex-col gap-1">
    <label>Payment Method</label>
    <span>{{item?.paymentMethodTypeName || '-none-'}}</span>
  </div>
</div>
